import { render } from "./CashierCash.vue?vue&type=template&id=224504f4"
import script from "./CashierCash.vue?vue&type=script&lang=js"
export * from "./CashierCash.vue?vue&type=script&lang=js"

import "./CashierCash.vue?vue&type=style&index=0&id=224504f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__